var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20.978px",
    height: "15.33px",
    viewBox: "0 0 24 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8761 0.875H3.12542C2.69744 0.875 2.28699 1.04501 1.98436 1.34764C1.68173 1.65027 1.51172 2.06072 1.51172 2.4887V14.5914C1.51172 15.0194 1.68173 15.4299 1.98436 15.7325C2.28699 16.0351 2.69744 16.2051 3.12542 16.2051H20.8761C21.3041 16.2051 21.7145 16.0351 22.0171 15.7325C22.3198 15.4299 22.4898 15.0194 22.4898 14.5914V2.4887C22.4898 2.06072 22.3198 1.65027 22.0171 1.34764C21.7145 1.04501 21.3041 0.875 20.8761 0.875Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.51172 6.52344H22.4898",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0352 12.1719H18.4557",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMenuIcon);
export default __webpack_public_path__ + "static/media/paymentMenuIcon.4b9596143d64c422f8ef6106bbe0c0e6.svg";
export { ForwardRef as ReactComponent };